import { Col, DatePicker, Form, Input, Row } from 'antd';
import { cpfMask } from 'masks-br';
import React from 'react';

const FormUser = ({ default_message, form }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        marginBottom: '18px',
      }}
    >
      {/* Seção: Dados da Pessoa */}
      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item
            name="nome"
            label="Nome"
            rules={[{ required: true, message: default_message }]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item
            name="cpf"
            label="CPF"
            rules={[{ required: true, message: default_message }]}
          >
            <Input
              onChange={e =>
                form.setFieldsValue({ cpf: cpfMask(e.target.value) })
              }
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="rg" label="RG">
            <Input maxLength={14} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item name="orgao_emissor" label="Órgão Emissor">
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="estado_emissor" label="Estado Emissor">
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="data_nascimento" label="Data Nascimento">
            <DatePicker
              placeholder=""
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item name="cod_usuario" label="Código do Usuário">
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item
            name="email"
            label="E-mail"
            rules={[{ required: true, message: default_message }]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default FormUser;
